import { Injectable, computed, inject } from '@angular/core'

import { ColorForm, ColorRenderer, DEFAULT_THEME_TYPE } from './color.entity'
import { getShadesFromTheme } from './color.helpers'

import { Section } from '../../constants/sections.constants'
import { ThemePathsMap } from '../../model/sections.model'
import { ThemeEditorStore } from '../../services/theme-editor.store'
import { ColorTokens } from '../../services/theme-model/colors'

@Injectable()
export class FlxThemeColorService {
  readonly #store = inject(ThemeEditorStore)

  readonly colorData = computed(() => this.#store.dataAt<ColorTokens>(Section.Color))

  readonly formData = computed(() => {
    const colors = this.colorData()
    return colors ? this.#parseFormColorData(colors) : null
  })

  readonly renderData = this.#store.previewComputed(() => {
    const colors = this.colorData()
    return colors ? this.#parseRenderColorData(colors) : []
  })

  updateData(colorForm: ColorForm): void {
    const colorPath = `${ThemePathsMap[Section.Color]}.${colorForm.path}`
    this.#store.updateThemeDataAtPath<ColorTokens>(colorPath, colorForm.fg, Section.Color)
  }

  #parseFormColorData(colorData: ColorTokens): Array<ColorForm> {
    return Object.entries(colorData).map(([key, colorToken]) => ({
      name: colorToken.name,
      fg: { ...colorToken[DEFAULT_THEME_TYPE] },
      path: `${key}.${DEFAULT_THEME_TYPE}`,
    }))
  }

  #parseRenderColorData(colorData: ColorTokens): Array<ColorRenderer> {
    return Object.entries(colorData).map(([color, colorToken]) => {
      const shades = getShadesFromTheme(colorToken[DEFAULT_THEME_TYPE])
      // Remove shades(0) from the array
      return { name: colorToken.name, shades: color === 'shades' ? shades.slice(1) : shades }
    })
  }
}
